import { useQuery } from '@tanstack/react-query';
import useScopedSentryMessage from 'hooks/useScopedSentryMessage';
import { useAppSelector } from 'store';
import { selectUser } from 'store/selectors/me/user';
import type { PendingPolicyNotice } from 'types/models/policy';
import { getPendingPolicyNotices } from 'utils/api/policies';

export const POLICY_NOTICES_PENDING_QUERY_KEY = 'POLICY_NOTICES_PENDING';

const usePendingPolicyNotices = () => {
  const logError = useScopedSentryMessage('error');
  const isLoggedIn = !!useAppSelector(selectUser)?._id;

  const { data, isLoading, error } = useQuery({
    queryKey: [POLICY_NOTICES_PENDING_QUERY_KEY],
    queryFn: (): Promise<PendingPolicyNotice[]> =>
      getPendingPolicyNotices().then((res) => res.data),
    enabled: isLoggedIn,
    onError: (queryError) => {
      logError('Failed to load pending policy notices', { extra: { error: queryError } });
    },
  });

  return { notices: data ?? [], isLoading, error };
};

export default usePendingPolicyNotices;
